import {
  createContext,
  CSSProperties,
  Dispatch,
  RefObject,
  SetStateAction,
} from "react";
import { PopoverProps } from "./Popover";
import { Placement } from "@floating-ui/react-dom";
import { FocusableElement } from "tabbable";

export type PopoverContextProps = {
  popoverId: string;
  invoker?: HTMLElement;
  setInvoker?: Dispatch<SetStateAction<HTMLElement | undefined>>;
  popover?: HTMLElement;
  setPopover?: Dispatch<SetStateAction<HTMLElement | undefined>>;
  rootNode?: Node;
  setRootNode?: Dispatch<SetStateAction<Node | undefined>>;
  arrowElement?: HTMLSpanElement;
  setArrowElement?: Dispatch<SetStateAction<HTMLSpanElement | undefined>>;
  openState: boolean;
  setOpenState: Dispatch<SetStateAction<boolean>>;
  popoverStyle?: CSSProperties;
  placement?: Placement;
  openPopover: () => void;
  closePopover: (replacementFn?: () => void) => void;
  onClose?: PopoverProps["onClose"];
  openOnHover: PopoverProps["openOnHover"];
  controlled: boolean;
  disableCloseOnClickOutside?: PopoverProps["disableCloseOnClickOutside"];
  disableCloseOnEscape?: PopoverProps["disableCloseOnEscape"];
  modal?: PopoverProps["modal"];
  noPadding?: PopoverProps["noPadding"];
  fillAvailableHeight: PopoverProps["fillAvailableHeight"];
  maxHeight: PopoverProps["maxHeight"];
  matchReferenceWidth: PopoverProps["matchReferenceWidth"];
  fixedWidth: PopoverProps["fixedWidth"];
  disableCaret: PopoverProps["disableCaret"];
  disableFlipFallback: PopoverProps["disableFlipFallback"];
  disableFocusLock: PopoverProps["disableFocusLock"];
  disableTriggerFocus: PopoverProps["disableTriggerFocus"];
  arrowRef: RefObject<HTMLSpanElement>;
  resetKey: number;
  focusables: FocusableElement[] | null;
};

export const PopoverContext = createContext<PopoverContextProps | null>(null);
